import { useTranslation } from "react-i18next";

export default function CalibrationCrumb(): string {
  const { t } = useTranslation();
  return t("crumb.Calibration");
}
